

























































































import Vue, { PropType } from 'vue';
import VueMarkdown from 'vue-markdown';
import { mapGetters } from 'vuex';
import EyeCheckOutlineIcon from 'vue-material-design-icons/EyeCheckOutline.vue';
import AnnotationModel from '@/dex-shared/models/AnnotationModel';

export default Vue.extend({
  components: {
    VueMarkdown,
    EyeCheckOutlineIcon,
  },
  props: {
    annotation: {
      type: Object as PropType<AnnotationModel>,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      tooltips: [],
    };
  },
  computed: {
    ...mapGetters({
      highlightedAnnotationHovered: 'highlightedAnnotationHovered',
      highlightedAnnotationClicked: 'highlightedAnnotationClicked',
    }),
    color(): string {
      return this.annotation
        .correctionScore()
        .knowledge()
        .color();
    },
    isHighlighted(): boolean {
      return (
        this.highlightedAnnotationHovered == this.annotation.id ||
        this.highlightedAnnotationClicked == this.annotation.id
      );
    },
  },
  mounted() {
    this.tooltips = Array.from(this.$el.querySelectorAll('abbr'));
    this.tooltips.forEach((tooltip: HTMLElement) => {
      tooltip.addEventListener('click', this.toggleTooltip);
      tooltip.addEventListener('touchstart', this.toggleTooltip);
      tooltip.addEventListener('mouseenter', this.toggleTooltip);
      tooltip.addEventListener('mouseleave', this.toggleTooltip);
    });
  },
  beforeDestroy() {
    this.tooltips.forEach((tooltip: HTMLElement) => {
      tooltip.removeEventListener('click', this.toggleTooltip);
      tooltip.removeEventListener('touchstart', this.toggleTooltip);
      tooltip.removeEventListener('mouseenter', this.toggleTooltip);
      tooltip.removeEventListener('mouseleave', this.toggleTooltip);
    });
  },
  methods: {
    highlightAnnotation(type: 'click' | 'hover') {
      this.$store.commit('HIGHLIGHT_ANNOTATION', {
        type,
        annotationId: this.annotation.id,
      });
    },
    toggleTooltip(e: Event) {
      this.$store.commit('TOGGLE_SKILL_DESCRIPTION', e);
    },
  },
});
